import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "container"
}
const _hoisted_2 = { class: "flex flex--gap-large flex--align-center mb-32" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " View: ", -1 /* HOISTED */)
const _hoisted_4 = {
  ref: "load_more_trigger",
  class: "load-more-trigger"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PageLoaderComponent = _resolveComponent("PageLoaderComponent")
  const _component_TabNavigationComponent = _resolveComponent("TabNavigationComponent")
  const _component_LightswitchComponent = _resolveComponent("LightswitchComponent")
  const _component_NotificationsComponent = _resolveComponent("NotificationsComponent")

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      ($data.loading)
        ? (_openBlock(), _createBlock(_component_PageLoaderComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            ($options.tabs)
              ? (_openBlock(), _createBlock(_component_TabNavigationComponent, {
                  key: 0,
                  tabs: $options.tabs,
                  "active-tab": $data.active_tab,
                  onSetTab: $options.setTab
                }, null, 8 /* PROPS */, ["tabs", "active-tab", "onSetTab"]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_LightswitchComponent, {
                label: "All",
                "off-label": "All",
                checked: $options.all_filters_active,
                disabled: $data.loading || $data.loading_notifications,
                onChange: $options.toggleAllFilters
              }, null, 8 /* PROPS */, ["checked", "disabled", "onChange"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filters, (filter, index) => {
                return (_openBlock(), _createBlock(_component_LightswitchComponent, {
                  key: `filter-${index}`,
                  label: filter.label,
                  "off-label": filter.label,
                  checked: filter.active,
                  disabled: $data.loading || $data.loading_notifications,
                  onChange: $event => ($options.toggleFilter( filter ))
                }, null, 8 /* PROPS */, ["label", "off-label", "checked", "disabled", "onChange"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            ($setup.loading_first_page_notifications)
              ? (_openBlock(), _createBlock(_component_PageLoaderComponent, { key: 1 }))
              : (_openBlock(), _createBlock(_component_NotificationsComponent, {
                  key: 2,
                  notifications: $setup.all_notifications,
                  "pending-count": $setup.all_notifications_pagination.pending_count,
                  loading: $data.loading_notifications,
                  onMarkAllAsRead: $options.markAllAsRead
                }, null, 8 /* PROPS */, ["notifications", "pending-count", "loading", "onMarkAllAsRead"])),
            _withDirectives(_createElementVNode("div", _hoisted_4, null, 512 /* NEED_PATCH */), [
              [_vShow, $setup.all_notifications_pagination.total_count > $setup.all_notifications.length]
            ])
          ]))
    ]),
    _: 1 /* STABLE */
  }))
}